@if (areLayoutElementsHidden()) {
  <div
    [class.bg-grey-10]="shouldUseGreyBackground()"
    [class.bg-white]="!shouldUseGreyBackground()"
    class="container"
    id="varden2"
  >
    <router-outlet></router-outlet>
  </div>
} @else {
  <mat-sidenav-container
    (backdropClick)="closeSidebarNav()"
    [hasBackdrop]="true"
  >
    <mat-sidenav-content
      [class.bg-grey-10]="shouldUseGreyBackground()"
      [class.bg-white]="!shouldUseGreyBackground()"
      class="flex h-screen flex-col">
      <app-header></app-header>
      <div
        [class.narrow]="shouldUseNarrowMainContainer()"
        class="container basis-full"
        id="varden"
      >
        <router-outlet></router-outlet>
      </div>
      <app-footer></app-footer>
      <!--      <app-mobile-fullscreen-popup></app-mobile-fullscreen-popup>-->
      <app-spinner></app-spinner>
    </mat-sidenav-content>
    <mat-sidenav
      [fixedInViewport]="true"
      [mode]="'over'"
      [opened]="isMenuOpen()"
      [position]="'end'"
    >
      <app-sidebar-nav></app-sidebar-nav>
    </mat-sidenav>
  </mat-sidenav-container>
}
